const SET_LOAN_DETAILS = "SET_LOAN_DETAILS";
const SAVE_LOAN_DETAILS = "SAVE_LOAN_DETAILS";

export { SET_LOAN_DETAILS, SAVE_LOAN_DETAILS };
